import { Box, Button, ChakraProvider, Heading, HStack } from "@chakra-ui/react";
import EsgTheme from "../../theme";
import { colors } from "theme/foundations/colors";
import { CaretDoubleLeft, CaretRight, Sparkle, X } from "@phosphor-icons/react";
import { useRightSidebar } from "context/RightSidebarContext";

export default function RightSidebarWidget() {
  const { isOpen, doClose, rightSidebar, size, setSize, closable } = useRightSidebar();

  const position = "fixed";

  return (
    <ChakraProvider theme={EsgTheme}>
      <Box
        id="rightSidebarContainer"
        borderLeft="solid 1px"
        borderColor="gray.300"
        style={{
          position: position,
          top: "70px", // avoid the top navbar
          right: isOpen ? "0" : "-100%", // Move fully off-screen when closed
          bottom: "0",
          width: { lg: "40vw", md: "30vw", sm: "20vw" }[size] || "30vw",
          overflowY: "auto",
          backgroundColor: colors.sidebar_background,
          padding: "0.1em",
          transition: "right 0.3s ease-in-out", // Slide effect
          display: "flex",
          flexDirection: "column",
          boxShadow: isOpen ? "0px 4px 10px rgba(0,0,0,0.1)" : "none", // Adds a shadow when open
        }}
      >
        {(doClose || setSize) && (
          <HStack justifyContent="space-between" bg="transparent">
            {size !== "lg" && (
              <Button onClick={() => setSize("lg")} variant="ghost">
                <CaretDoubleLeft />
              </Button>
            )}
            {size === "lg" && (
              <Button onClick={() => setSize("md")} variant="ghost">
                <CaretRight />
              </Button>
            )}
            {doClose && closable && (
              <Button onClick={doClose} variant="ghost">
                <X />
              </Button>
            )}
          </HStack>
        )}
        <div style={{ padding: "0.8em", flexGrow: 1 }}>{isOpen ? rightSidebar : null}</div>
      </Box>
    </ChakraProvider>
  );
}

/**
 * Sidebar Header Component
 */
export function RightSidebarHeader({ Icon, children }) {
  let weight;
  if (Icon === Sparkle) {
    weight = "fill";
  }
  return (
    <HStack bg="transparent" w="full">
      {Icon && <Icon color={colors.headingLime} weight={weight} size={32} />}
      <Heading as="h2" ml={1} fontSize="heading.l" color="darkTeal" w="full">
        {children}
      </Heading>
    </HStack>
  );
}
